import React, { useEffect, useState } from 'react';
import '../styles/AgenticTimeline.css';
import { AgenticTimelineChip, Button, ChatActionRequired, Typewriter } from './';
import { recordEvent, renderHTML } from '../functions';
import { Arrow } from '../assets/icons';
import { colour } from '../styles/GlobalStyles';

function AgenticTimeline(props) {
    // 1. Gathered comps
    // 2. Market analysis
    // 3. Starting with close comps (show comps on map with location score above 70?)
    // 4. Filter on construction
    // 5. Filter on pool
    // 6. Filter on beds/baths
    // 7. Arranging into groups (table view?)
    // 8. Getting top 5 ARV comps
    // 9. Curb appeal findings
    // 10. ARV Estimate

    const streetViewAnalysis = props.streetViewAnalysis;
    const streetViewIndex = streetViewAnalysis.findIndex(e => e.imageHighlights.length >= 3);
    const streetViewObject = streetViewIndex === -1 ? null : streetViewAnalysis[streetViewIndex].imageHighlights;
    const steps = props.steps;
    const actionRequired = props.actionRequired;
    const selectScenario = props.selectScenario;
    const scenarios = props.scenarios;
    const textFinished = props.textFinished;
    const typeOutText = props.typeOutText;
    const setShowAgenticTimeline = props.setShowAgenticTimeline;
    const finished = props.finished;
    const innerWidth = props.innerWidth;
    // const allComps = props.allComps;
    // const property = props.property;
    // const anomaly = props.anomaly;
    // const redfinData = props.redfinData;
    // const continueAgenticFlow = props.continueAgenticFlow;
    // const showScrollableImages = props.showScrollableImages;
    const stepTitles = [
        {
            title: "Gathering all comps...",
            defaultDescription: null,
            label: "gather_comps"
        },
        {
            title: "Getting Redfin market data...",
            defaultDescription: null,
            label: "redfin_data"
        },
        {
            title: "Getting US Census Bureau data...",
            defaultDescription: null,
            label: "census_data"
        },
        {
            title: "Analyzing subject's curb appeal...",
            defaultDescription: "We're pulling Street View and Satellite images on the subject property. We'll check whether the property backs onto notable features like highways, golf courses, or bodies of water. We'll take a peak in the neighbor's yard too 👀",
            label: "subject_curb_appeal"
        },
        {
            title: "Running market analysis...",
            defaultDescription: "Looking for unconventional factors that can impact how we choose the best comps. Things like gated communities, waterfront properties, premium subdivisions etc.",
            label: "market_analysis"
        },
        {
            title: "Starting with close comps...",
            defaultDescription: null,
            label: "initial_radius"
        },
        {
            title: "Analyzing property build type...",
            defaultDescription: null,
            label: "primary_build_type"
        },
        {
            title: "Analyzing property build type...",
            defaultDescription: null,
            label: "secondary_build_type"
        },
        {
            title: "Analyzing property build type...",
            defaultDescription: null,
            label: "tertiary_build_type"
        },
        {
            title: "Analyzing property build type...",
            defaultDescription: null,
            label: "build_type"
        },
        {
            title: "Applying more filters...",
            defaultDescription: null,
            label: "additional_filters"
        },
        {
            title: "Applying more filters...",
            defaultDescription: null,
            label: "primary_additional_filters"
        },
        {
            title: "Expanding radius...",
            defaultDescription: null,
            label: "expanding_radius"
        },
         {
            title: "Expanding radius...",
            defaultDescription: null,
            label: "expanding_radius_secondary"
        },
         {
            title: "Expanding radius...",
            defaultDescription: null,
            label: "expanding_radius_tertiary"
        },
        {
            title: "Wider market analysis...",
            defaultDescription: "Checking whether the expanded radius has any unconventional market factors at play (e.g. gated communities, waterfront properties, premium subdivisions etc.)",
            label: "market_analysis_secondary"
        },
        {
            title: "Widest market analysis...",
            defaultDescription: "Checking whether the expanded radius has any unconventional market factors at play (e.g. gated communities, waterfront properties, premium subdivisions etc.)",
            label: "market_analysis_tertiary"
        },
        {
            title: "Applying more filters...",
            defaultDescription: null,
            label: "secondary_additional_filters"
        },
        {
            title: "Applying more filters...",
            defaultDescription: null,
            label: "tertiary_additional_filters"
        },
        {
            title: "🚨 MAJOR COMPROMISES 🚨",
            defaultDescription: null,
            label: "major_comp_compromise"
        },
        {
            title: "Arranging comps into groups...",
            defaultDescription: null,
            label: "grouping"
        },
        {
            title: "Getting best ARV comps",
            defaultDescription: "Choosing comps that best fit the subject property based on location, recency similarity, and other factors.",
            label: "arv_comp_selection"
        },
        {
            title: "Analyzing curb appeal",
            defaultDescription: "Checking the street view and satellite images of each comp to determine the curb appeal of each property.",
            label: "curb_appeal"
        },
        {
            title: "Calculating ARV",
            defaultDescription: "Calculating the final ARV estimate based on the best comps we selected.",
            label: "arv_calculation"
        }
    ];
    const [loaded, setLoaded] = useState(false);
    const [typingStep, setTypingStep] = useState(null);
    const lastLoadedIndex = steps.findIndex(e => e.loaded === false);
    const lastLoadedStep = typingStep !== null ? typingStep : lastLoadedIndex === -1 ? steps.length - 1 : lastLoadedIndex;

    useEffect(() => {

        if ( loaded === false && steps.length > 0 ) {
            setLoaded(true);
            setTypingStep(lastLoadedIndex === -1 ? steps.length - 1 : lastLoadedIndex - 1);
        }
    }, [lastLoadedIndex, loaded, steps.length]);

    const closeTimeline = () => {
        recordEvent("close_agentic_timeline", {});
        setShowAgenticTimeline(false);
    };

    return (
        <div className="agentic-timeline-outer-container">
            <div className="agentic-timeline-inner-container">
                <div className={"agentic-timeline-button-container " + (innerWidth < 1000 && finished === false ? "mobile-none" : "")}>
                    <Button
                        buttonType="light-button"
                        size="large"
                        text={"Continue to report"}
                        cta={() => closeTimeline()}
                        disabled={!finished}
                        leftIcon={null}
                        leftIconClass=""
                        rightIcon={<Arrow fill={colour.gray06} className="reverse" />}
                        rightIconClass=""
                        alt=""
                        standardIcon={false}
                        badge={false}
                        badgeVal={null}
                        badgeBG={null}
                        buttonRef={null}
                        spinner={false}
                    />
                </div>
                <div className="agentic-timeline-body-container">
                    {
                        loaded === false ?
                        <div className={"agentic-timeline-step-row relative-container agentic-timeline-regular-width"}>
                            <div className="agentic-timeline-step-left">
                                <AgenticTimelineChip
                                    loaded={false}
                                />
                            </div>
                            <div className="agentic-timeline-step-right">
                                <h2 className="heading-small-bold colour-white">
                                    Gathering all comps...
                                </h2>
                            </div>
                        </div>
                        :
                        steps.map((item, index) => (
                            (index > lastLoadedStep) || (typingStep !== null && index > typingStep) ? null :
                            <div 
                                key={index} 
                                className={"agentic-timeline-step-row relative-container " + (item.label === "arv_calculation" && stepTitles.find(step => step.label === item.label)?.title === "ACTION_REQUIRED" ? "" : "agentic-timeline-regular-width")}
                            >
                                {
                                    index < lastLoadedStep &&
                                    <div className="timeline-vertical-line" />
                                }
                                <div className="agentic-timeline-step-left">
                                    <AgenticTimelineChip
                                        loaded={item.loaded}
                                    />
                                </div>
                                <div className="agentic-timeline-step-right">
                                    <h2 className="heading-small-bold colour-white">
                                        {
                                            stepTitles.find(step => step.label === item.label)?.title
                                        }
                                    </h2>
                                    {
                                        item.label === "curb_appeal" && streetViewObject !== null &&
                                        <div className="agentic-timeline-curb-appeal-container">
                                            <span className="body-regular colour-tertiary">
                                                We analyzed street view &amp; satellite images <span className="text-italic">near</span> each comp
                                                to determine the curb appeal of each property.
                                            </span>
                                            {
                                                streetViewObject.map((el, ii) =>
                                                    <div
                                                        className="agentic-timeline-curb-appeal-element"
                                                        key={ii}
                                                    >
                                                        <div className="agentic-timeline-curb-appeal-line" />
                                                        <span className="body-regular colour-tertiary">
                                                            {el.address}
                                                        </span>
                                                        <span className="body-semibold colour-white">
                                                            {el.note}
                                                        </span>
                                                        <img
                                                            src={el.image_url}
                                                            className="agentic-timeline-curb-appeal-image"
                                                            alt={el.note}
                                                        />
                                                    </div>
                                                )
                                            }
                                        </div>
                                    }
                                    {
                                        item.label === "arv_calculation" && item.description === "ACTION_REQUIRED" ?
                                        <ChatActionRequired
                                            scenarios={scenarios}
                                            actionRequired={actionRequired}
                                            textFinished={textFinished}
                                            typeOutText={typeOutText}
                                            selectScenario={selectScenario}
                                            timeline={true}
                                            darkMode={true}
                                            key={index}
                                        />
                                        :
                                        item.loaded === true && item.description !== null && index === lastLoadedStep ?
                                        <Typewriter
                                            text={item.description}
                                            delay={10}
                                            commaDelay={0}
                                            fullStopDelay={0} 
                                            play={true}
                                            className="body-regular colour-tertiary block-text white-space-pre-wrap"
                                            isHTML={true}
                                            onStart={() => setTypingStep(index)}
                                            onComplete={() => setTypingStep(index + 1)}
                                        />
                                        :
                                        item.loaded === true && item.description !== null ?
                                        <div
                                            className="body-regular colour-tertiary block-text white-space-pre-wrap"
                                            dangerouslySetInnerHTML={{ __html: renderHTML(item.description) }} // Renders Markdown as HTML
                                        />
                                        :
                                        item.loaded === false && stepTitles.find(step => step.label === item.label)?.defaultDescription !== null ?
                                        <span className="body-regular colour-tertiary">
                                            {stepTitles.find(step => step.label === item.label)?.defaultDescription}
                                        </span>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                        ))
                    }
                    {/* {
                        property && anomaly ?
                        <AgenticQuestion
                            anomaly={anomaly}
                            allComps={allComps}
                            innerWidth={innerWidth}
                            property={property}
                            redfinData={redfinData}
                            continueAgenticFlow={continueAgenticFlow}
                            showScrollableImages={showScrollableImages}
                        />
                        :
                        null
                    } */}
                </div>
            </div>
        </div>
    );
}

export default AgenticTimeline;